module.exports = __webpack_public_path__ + "img/reassurance.959ea911.png";